module.exports = __webpack_public_path__ + "media/images/pl02-70a37ff5670d235039a86d41dbf8d805.jpg";